import { PREDEFINED_ROLES } from './constants'

export const initialState = {
  roles: PREDEFINED_ROLES,
  users: [],
  scenario: [],
  instances: [],
  output: []
}
